import React, { memo } from 'react';

//Components.
import Video from '../../video-component/Video'

//Dependencies.
import { useLocation, useParams } from 'react-router-dom'
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';

//Functions.
  import { updateActiveChallengeInFS } from '../../../functions/firebase/firestore';
  //Selectors.
  import { useDispatch, useSelector } from 'react-redux';
  //Slices and ActionCreators.
  import { allActiveChallenges, allUpcomingChallenges, updateChallenge, updateFSupcomingChallenges, updateReduxWithFSupcomingChallengesData } from '../../../slices/challengesSlice';
  import { loggedInUser } from '../../../slices/allUsersSlice';
  import { updateChallengeAnnouncementInFS } from '../../../functions/firebase/firestore';
  
import './VideoCardComponent.styles.css'



const VideoCardComponent = ({ addToChallengeButton, source, link, ...otherVideoProps }) => {
   const announcements = useSelector(allUpcomingChallenges);
   const activeChallenges = useSelector(allActiveChallenges);
   const currentUser = useSelector(loggedInUser);
   const dispatch = useDispatch();
   const location = useLocation();
   const params = useParams();

   let { title, description, _userID, _videoID, record, votes, winner, winningVotes } = otherVideoProps;

   if (location.pathname.endsWith("challenges/create")) {
      const { setChallengeVideos, challengeVideos } = otherVideoProps;

      return (
         <Card style={{border: "1.75px solid black", maxWidth: '100%', height: 'auto'}} className='videoCardComponent'>
            <CardHeader className='p-1' style={{overflow: 'hidden'}}>
               <Video source={source} link={link} />
            </CardHeader>
            <CardBody>
               <strong className='text-danger'>{title}</strong>
               <br />
               <span>By: {_userID}</span>
            </CardBody>
            <CardFooter style={{display: 'flex', justifyContent: 'center'}}>
               <Button size="md" color={challengeVideos[_videoID] ? "danger" : "success"} onClick={() => {
                  if (challengeVideos[_videoID]) {
                     const { [_videoID]: selectedVideo, ...otherVideos } = challengeVideos;
                     setChallengeVideos(prvChallengeVideos => ({ ...otherVideos }));
                  } else {
                     setChallengeVideos(prvChallengeVideos => ({ ...prvChallengeVideos, [_videoID]: { _userID, _videoID, title, record, source, link, votes: 0, winner: false } })) //Removed description property because it was undefined and Firestore cannot have an undefined property.
                  }
               }}>{ challengeVideos[_videoID] ? "UNSELECT" : "SELECT" }</Button>
            </CardFooter>
         </Card>
      )
   }
   else if (params._challengeID && location.pathname.endsWith(`details/announcement/${params._challengeID}`)) {
      function handleUpcomingChallengeUpdate() {
         const upcomingChallengeUpdated = { ...announcements[params._challengeID], challengeVideos: { ...announcements[params._challengeID].challengeVideos, [_videoID]: { _userID, _videoID, link, record, source, title, votes: 0, winner: false } } };

         //===== START: Update FS with new data, then update Redux. =====
         updateChallengeAnnouncementInFS(params._challengeID, { ...upcomingChallengeUpdated }) //updates firestore.
            .then(successMessage => {
               console.log({ message: `Successfully updated ${params._challengeID} inside firestore!`, payload: upcomingChallengeUpdated, successMessage });
               dispatch(updateReduxWithFSupcomingChallengesData()); //updates Redux.
            })
            .catch(error => console.error({ errorOrigin: 'handleUpcomingChallengeUpdate function', error, errorMessage: error.message, errorCode: error.code }));
         //===== END: Update FS with new data, then update Redux. =====
         
      } //Adds a new video to the challenge announcement. I also removed the description property.

      return (
         <Card style={{border: "1.75px solid black"}} className='videoCardComponent mb-5'>
            <CardHeader className='mx-0 px-0 bg-black' style={{overflow: 'hidden'}}>
               <Video source={source} link={link} />              
            </CardHeader>
            <CardBody>
               <strong className='text-danger'>{title}</strong>
               <br />
               <span>By: {_userID}</span>
               <br />
               <strong>{description}</strong>
            </CardBody>
            {
               (addToChallengeButton &&
               location.pathname.endsWith(`announcement/${params._challengeID}`))
               &&
               <CardFooter>
                  <div className="d-grid gap-2">
                     <button className="btn btn-danger" type="button" onClick={handleUpcomingChallengeUpdate}>ADD VIDEO.</button>
                  </div>
               </CardFooter>
            }
         </Card>
      )
   }
   else if ( activeChallenges[params._challengeID] && location.pathname.endsWith(`details/active/${params._challengeID}`) ) {
      const {
         _ownerID,
         challengeVideos,
         activeChallengeProperties: {
            howWillActiveChallengeEnd,
            endActiveChallenge,
            voters, //voters = []. Each element = _userID.
            winningVotes,
            winner
         }
      } = activeChallenges[params._challengeID];

      function handleVote() {
         const { challengeVideos } = activeChallenges[params._challengeID];

         const updatedChallengeVideo = { [_videoID]: { ...otherVideoProps, source, link, votes: votes += 1 } };

         const votersUpdated = [...voters, currentUser._userID]

         const updatedChallenge = {
            [params._challengeID]: {
               ...activeChallenges[params._challengeID],
               activeChallengeProperties: {
                  ...activeChallenges[params._challengeID].activeChallengeProperties, voters: [...votersUpdated]
               },
               challengeVideos: { ...challengeVideos, ...updatedChallengeVideo }
            }
         }

         const updateVoteInReduxPromise = new Promise((res, rej) => {
            dispatch(updateChallenge({ type: 'active', key: params._challengeID, value: updatedChallenge[params._challengeID] }));
            res({ ...updatedChallenge[params._challengeID] });
            rej({ message: "Error executing the following dispatch/action-creator: updateChallenge", updatedChallengeValues: updatedChallenge[params._challengeID] });
         })

         updateVoteInReduxPromise
            .then(result => updateActiveChallengeInFS(params._challengeID, { ...result }))
            .then(successMessage => {
               console.log({ message: `Successfully updated vote count inside ${params._challengeID}!!!`, successMessage, updatedChallengeValues: updatedChallenge[params._challengeID] });
            })
            .catch(error => console.error({ error, errorCode: error.code, errorMessage: error.message }))
      }

      return (
         <Card style={{border: "1.75px solid black"}} className='videoCardComponent'>
            <CardHeader className='mx-0 px-0 bg-black' style={{overflow: 'hidden'}}>
               <Video source={source} link={link} />
            </CardHeader>
            <CardBody>
               <strong className='text-danger'>{title}</strong>
               <br />
               <span>By: {_userID}</span>
               <br />
               <strong>votes: {votes}</strong>
            </CardBody>
            {
               currentUser._userID ?
               ((!voters.includes(currentUser._userID)) || currentUser.username === 'admin' ?
               <div className="d-grid gap-2">
                  <button className="btn btn-danger m-1" type="button" onClick={handleVote} disabled={endActiveChallenge}>VOTE FOR THIS VIDEO!!!</button>
               </div>
               :
               <div className="d-grid gap-2">
                  <button className="btn btn-danger m-1" type="button" disabled={true}>YOU ALREADY VOTED FOR THIS CHALLENGE, {currentUser.username}!!!</button>
               </div>)
               :
               <div className="d-grid gap-2">
                  <button className="btn btn-success m-1" type="button" disabled>LOGIN OR SIGN UP TO VOTE!!!</button>
               </div>               
            }
            
         </Card>
      )
   }
   else {
      return (
         <Card style={{border: "1.75px solid black"}} className='videoCardComponent'>
            <CardHeader className='mx-0 px-0 bg-black' style={{ overflow: 'hidden'}}>
               <Video source={source} link={link} />               
            </CardHeader>
            <CardBody>
               <strong className='text-danger'>{title}</strong>
               <br />
               <span>By: {_userID}</span>
               <br />
               <span className='text-danger'><strong>Wins:</strong></span><strong className='px-1'>{record.wins}. </strong>
               <span className='text-danger'><strong>Losses:</strong></span><strong className='px-1'>{record.losses}.</strong>
               <span className='text-danger'><strong>Ties:</strong></span><strong className='px-1'>{record.ties}. </strong>
               <span style={{color: 'firebrick'}}><strong>Win Percent:</strong></span><strong className='px-1' style={{backgroundColor: 'yellow'}}>{record.winPct}. </strong>
               <br />
               <strong>{description}</strong>
            </CardBody>
            <CardFooter>
            </CardFooter>
         </Card>
      )
   }   
}

export default memo(VideoCardComponent);